import {
    Directive,
    ElementRef,
    HostBinding,
    HostListener,
    AfterViewInit,
    Optional,
    Self
} from '@angular/core';

import { NgControl } from '@angular/forms';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'textarea[autosizeTextArea]',
    standalone: false
})
export class AutosizeTextAreaDirective implements AfterViewInit {

    private previousValue: string;

    @HostBinding('attr.rows') rows: string = '1';

    constructor(private _elementRef: ElementRef, @Optional() @Self() formControl: NgControl) {
        if (formControl && formControl.valueChanges) {
            formControl.valueChanges.subscribe(() =>
                this.resizeTextAreaToFitContent()
            );
        }
    }

    ngAfterViewInit() {
        this.resizeTextAreaToFitContent();
    }

    @HostListener('input')
    onTextareaInput(): void {
        this.resizeTextAreaToFitContent();
    }

    resizeTextAreaToFitContent(): void {
        const textarea = this._elementRef.nativeElement as HTMLTextAreaElement;
        if (textarea.value === this.previousValue) {
            return;
        }

        // Reset the textarea height to auto to set default size.
        textarea.style.height = 'auto';

        // Set scroll height to fit its content.
        textarea.style.height = textarea.scrollHeight + 'px';

        textarea.focus();

        this.previousValue = textarea.value;
    }
}
